<template>
  <div>
    <a-card :head-style="{ background: '#f3f3f3' }">
      <template #title>增加配置</template>
      <div>
        <a-form :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
          <a-form-item label="供应商唯一商户号">
            <a-input v-model:value="formState.businessNo"></a-input>
          </a-form-item>
          <a-form-item label="供应商名称">
            <a-input
              placeholder="天君"
              v-model:value="formState.supplierName"
            ></a-input>
          </a-form-item>
          <a-form-item label="业务类型">
            <a-radio-group v-model:value="formState.businessType">
              <a-radio value="0">国内</a-radio>
              <a-radio value="1">国际</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="配置权限" :wrapper-col="{ span: 14 }">
            <a-radio-group v-model:value="formState.businessModules">
              <a-radio
                v-for="(item, index) in configPre"
                :key="index"
                :value="(index + 1) * 10"
                >{{ item }}</a-radio
              >
            </a-radio-group>
          </a-form-item>
          <a-form-item label="配置类型" :wrapper-col="{ span: 14 }">
            <a-radio-group v-model:value="formState.domesticPlaneConfType">
              <a-radio
                v-for="(item, index) in configType"
                :key="index"
                :value="index"
              >
                {{ item }}</a-radio
              >
            </a-radio-group>
          </a-form-item>
          <a-form-item label="出票类型">
            <a-radio-group v-model:value="formState.outTicketType">
              <a-radio
                v-for="(item, index) in outBill"
                :key="index"
                :value="index"
                >{{ item }}</a-radio
              >
            </a-radio-group>
          </a-form-item>
          <a-form-item label="配置账号">
            <a-input
              placeholder="例：O123456"
              v-model:value="formState.account"
            ></a-input>
          </a-form-item>
          <a-form-item label="配置密码">
            <a-input
              placeholder="配置密码"
              v-model:value="formState.password"
            ></a-input>
          </a-form-item>
          <a-form-item label="确认密码">
            <a-input placeholder="配置密码"></a-input>
          </a-form-item>
          <a-form-item label="工作组账号">
            <a-input
              placeholder="例：O123456"
              v-model:value="formState.groupAccount"
            ></a-input>
          </a-form-item>
          <a-form-item label="工作组密码">
            <a-input
              placeholder="工作组密码"
              v-model:value="formState.groupAccountPassword"
            ></a-input>
          </a-form-item>
          <a-form-item label="服务器">
            <a-input
              placeholder="例：47.100.20.224"
              v-model:value="formState.ecs"
            ></a-input>
          </a-form-item>
          <a-form-item label="端口">
            <a-input
              placeholder="例：335"
              v-model:value="formState.port"
            ></a-input>
          </a-form-item>
          <a-form-item label="OFFICE号">
            <a-input
              placeholder="例：PEK225"
              v-model:value="formState.office"
            ></a-input>
          </a-form-item>
          <a-form-item label="打票机号">
            <a-input
              placeholder="例：1"
              v-model:value="formState.ticketMachine"
            ></a-input>
          </a-form-item>
          <a-form-item label="出票量限制">
            <a-input
              placeholder="例：超过限制系统不会自动出票"
              v-model:value="formState.ticketNumLimit"
            ></a-input>
          </a-form-item>
          <a-form-item label="指令数限制">
            <a-input
              placeholder="例：超过限制将自动禁用配置"
              v-model:value="formState.instructionsLimit"
            ></a-input>
          </a-form-item>
          <a-form-item label="备注信息">
            <a-textarea
              placeholder="请输入内容"
              v-model:value="formState.remark"
            ></a-textarea>
          </a-form-item>
          <a-form-item :wrapper-col="{ offset: 8 }">
            <a-button @click="submit">提交</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import supply from "@/axios/supply";
export default {
  name: "addConfig",
  setup() {
    let formState = reactive({
      businessNo: "",
      supplierName: "",
      businessType: "",
      businessModules: "",
      domesticPlaneConfType: "",
      outTicketType: "",
      account: "",
      password: "",
      groupAccount: "",
      office: "",
      groupAccountPassword: "",
      ecs: "",
      port: "",
      ticketMachine: "",
      ticketNumLimit: "",
      instructionsLimit: "",
      remark: "",
    });
    const rules = {
      account: [
        {
          required: true,
          message: "Please input Activity name",
          trigger: "blur",
        },
      ],
    };
    let submit = () => {
      supply.addConfig(formState).then((res) => {
        console.log(res);
      });
    };
    return {
      rules,
      formState,
      submit,
      stateList: ["国际", "国内"],
      //   configPre: ["国内机票", "国内火车票", "国内酒店", "国内租车"],
      configPre: ["火车票", "酒店", "机票", "保险", "打车"],
      configType: [
        "eterm原始配置",
        "eterm放大配置",
        "Sabre",
        "Galileo",
        "Amade",
      ],
      outBill: ["BSP", "BOP"],
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 6,
      },
    };
  },
};
</script>

<style lang='scss' scoped>
/deep/ .ant-radio-checked .ant-radio-inner {
  border-color: #1bba79 !important;
}
</style>